<template lang="html">
  <div class="catalog-content flex flex-col gap-12">
    <CatalogCategories
      :link-mode="false"
      variant="short"
      :selected-category="selectedCategory"
      class="catalog-page__navigation w-full max-w-(--ui-container) sm:m-auto"
      @update:selected-category="emit('update:selectedCategory', $event)"
    />

    <CatalogShowcase
      class="catalog-page__showcase mb-2! w-full max-w-(--ui-container) sm:m-auto"
      :category="selectedCategory"
    />
  </div>
</template>

<script setup lang="ts">
import CatalogCategories from '#Products/components/Catalog/Navigation/CatalogCategories.vue'
import CatalogShowcase from '#Products/components/Catalog/Showcase/CatalogShowcase.vue'
import type { CategoryDto } from '#Products/models/Pim/CategoryDto'

defineProps<{
  selectedCategory?: CategoryDto
}>()

const emit = defineEmits<{
  'update:selectedCategory': [category: CategoryDto | undefined]
}>()
</script>
